import 'core-js/es6/promise'
import 'core-js/es6/symbol'
import 'core-js/fn/object/assign'
import 'core-js/fn/object/values'
import 'core-js/fn/array/from'
import 'core-js/fn/array/find'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/some'
import 'core-js/es6/map'
import 'core-js/es6/weak-map'
import 'core-js/es6/set'
import 'raf/polyfill'

import 'requestidlecallback'

import 'process'
import hrtime from 'browser-process-hrtime'
import { isIE } from './helpers'

process.hrtime = hrtime as any

// Fix "TypeMismatchError" & "'Request': Invalid argument" in Edge browsers
// https://github.com/aurelia/fetch-client/issues/81#issuecomment-265838094
;(function() {
    // When Edge is detected we need to drop in the inbuilt version of fetch and then polyfill a
    // version with the correct implementation. This check will only be true for EdgeHTML/Chakra
    // based versions of Edge. The Chromium version useragent drops the e "...Edg/75.0.109.0...".
    if (window.navigator.userAgent.indexOf('Edge') > -1) {
        delete window.fetch
    }
    // Apply fetch polyfill unsupported browsers
    require('isomorphic-fetch')

    /**
     * Some browsers do not support arbitrary time zone in Intl.DateTimeFormat API
     * (becuase its optional as per ECMA-402 standard).
     * This polyfill is only to bring this support.
     * Polyfill contains historical timezone data, CLDR data & tiny code to polyfill this support.
     *
     * https://github.com/formatjs/date-time-format-timezone#readme
     */
    if (isIE(window.navigator)) {
        require('date-time-format-timezone')
    }
})()

// ChildNode.remove() https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
;(function(arr) {
    arr.forEach(function(item) {
        // eslint-disable-next-line no-prototype-builtins
        if (item.hasOwnProperty('remove')) {
            return
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null) this.parentNode.removeChild(this)
            },
        })
    })
})([Element.prototype, CharacterData.prototype, DocumentType.prototype])
